import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Search } from "lucide-react";
import { adminApi, ESTADOS, fmtMoney } from "@/api";

export default function Clientes() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(null);

  const load = async (query = q) => {
    const { data } = await adminApi.get(`/crm/clientes${query ? `?q=${encodeURIComponent(query)}` : ""}`);
    setItems(data);
  };
  useEffect(() => { load(""); }, []);

  const openCliente = async (dni) => {
    const { data } = await adminApi.get(`/crm/clientes/${dni}`);
    setSel(data);
  };

  const wa = (c) => {
    const tel = (c.tel || c.tel_cel || "").replace(/\D/g, "");
    if (!tel) return null;
    return `https://wa.me/${tel.startsWith("54") ? tel : `549${tel}`}?text=${encodeURIComponent(`Hola ${c.nombre || ""}, te contactamos de Seguros Para Moto.`)}`;
  };

  return (
    <div data-testid="admin-clientes">
      <h1 className="font-heading text-2xl font-bold text-slate-900 mb-6">Clientes</h1>
      <div className="relative max-w-md mb-5">
        <Search className="w-4 h-4 absolute left-3 top-3 text-slate-400" />
        <input data-testid="clientes-search" placeholder="Buscar por nombre o DNI" value={q} onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && load()}
          className="w-full h-10 pl-9 pr-3 bg-white border border-slate-300 rounded-md text-sm focus:border-emerald-600 outline-none" />
      </div>
      <div className="grid lg:grid-cols-2 gap-4 items-start">
        <div className="bg-white border border-slate-200 rounded-lg divide-y divide-slate-100" data-testid="clientes-list">
          {items.map((c) => (
            <button key={c.dni} data-testid={`cliente-${c.dni}`} onClick={() => openCliente(c.dni)}
              className={`w-full text-left p-4 hover:bg-slate-50 transition ${sel?.cliente?.nrodoc === c.dni ? "bg-emerald-50" : ""}`}>
              <div className="flex justify-between items-center">
                <div>
                  <p className="font-medium text-slate-800">{c.apellido}, {c.nombre}</p>
                  <p className="text-xs text-slate-400">DNI {c.dni} - {c.mail}</p>
                </div>
                <div className="text-right text-xs text-slate-500">
                  <p>{c.operaciones} operac.</p>
                  <p className="text-green-700 font-semibold">{c.polizas} poliza(s)</p>
                </div>
              </div>
            </button>
          ))}
          {!items.length && <p className="p-8 text-center text-slate-400 text-sm" data-testid="empty-clientes">Todavia no hay clientes con datos cargados</p>}
        </div>
        {sel && (
          <div className="bg-white border border-slate-200 rounded-lg p-5" data-testid="cliente-ficha">
            <div className="flex justify-between items-start mb-4">
              <div>
                <h2 className="font-heading font-bold text-lg text-slate-900">{sel.cliente.apellido}, {sel.cliente.nombre}</h2>
                <p className="text-sm text-slate-500">DNI {sel.cliente.nrodoc} - {sel.cliente.mail}</p>
                <p className="text-sm text-slate-500">{sel.cliente.tel_cel}</p>
              </div>
              {wa(sel.cliente) && (
                <a data-testid="cliente-whatsapp-button" href={wa(sel.cliente)} target="_blank" rel="noreferrer"
                  className="flex items-center gap-2 h-10 px-4 rounded-md bg-[#25D366] text-white text-sm font-semibold shrink-0">
                  <MessageCircle className="w-4 h-4" /> WhatsApp
                </a>
              )}
            </div>
            <h3 className="text-xs font-semibold text-slate-500 uppercase mb-2">Historial de operaciones</h3>
            <div className="space-y-2">
              {sel.operaciones.map((op) => {
                const est = ESTADOS[op.estado] || ESTADOS.cotizado;
                return (
                  <Link key={op.public_id} to={`/atm-seguros/operaciones/${op.public_id}`} data-testid={`cliente-op-${op.public_id.slice(0, 8)}`}
                    className="block border border-slate-200 rounded-lg p-3 hover:bg-slate-50 transition">
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="text-sm font-medium text-slate-800">{op.vehiculo_cotizado?.marca_desc} {op.vehiculo_cotizado?.modelo_desc} {op.vehiculo?.patente ? `- ${op.vehiculo.patente}` : ""}</p>
                        <p className="text-xs text-slate-400">{(op.created_at || "").slice(0, 10)} - Op. {op.operacion}{op.cobertura_elegida ? ` - ${fmtMoney(op.cobertura_elegida.premio)}` : ""}</p>
                      </div>
                      <span className={`text-xs font-semibold px-2 py-1 rounded-full ${est.cls}`}>{est.label}</span>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
